import { ComponentRef } from '@angular/core';
import { GlobalDialogComponent } from '@shared/components/global-dialog/global-dialog.component';
import { Observable, Subject } from 'rxjs';

export class ModalRef<T> {
  private readonly _afterClosed = new Subject<boolean | undefined>();
  private readonly _afterConfirm = new Subject<unknown>();
  afterClosed: Observable<boolean | undefined> =
    this._afterClosed.asObservable();

  constructor(
    public readonly componentRef: ComponentRef<T>,
    public readonly modalWrapperRef: ComponentRef<GlobalDialogComponent>,
    private readonly hostElement: HTMLElement
  ) {
    this.modalWrapperRef.instance.cancel.subscribe(() => this.close());
  }

  close(result?: boolean): void {
    this._afterClosed.next(result);
    this._afterClosed.complete();

    if (this.hostElement && this.hostElement.parentNode) {
      this.hostElement.parentNode.removeChild(this.hostElement);
    }

    this.componentRef.destroy();
    this.modalWrapperRef.destroy();
  }

  confirm(data: unknown): void {
    this._afterConfirm.next(data);
  }

  afterConfirm<U>(): Observable<U> {
    return this._afterConfirm.asObservable() as Observable<U>;
  }
}
